import { render, staticRenderFns } from "./receiverControl.vue?vue&type=template&id=7712d1b5&scoped=true"
import script from "./receiverControl.vue?vue&type=script&lang=js"
export * from "./receiverControl.vue?vue&type=script&lang=js"
import style0 from "./receiverControl.vue?vue&type=style&index=0&id=7712d1b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7712d1b5",
  null
  
)

export default component.exports